import React, { Suspense } from 'react'
import { LoadingComponent } from '../../loading/index'

const MyActivity = React.lazy(() => import('./my-activity'))

const AsyncMyActivity = props => (
  <Suspense fallback={<LoadingComponent />}>
    <MyActivity {...props} />
  </Suspense>
)

export default AsyncMyActivity
